<template>
  <form v-on:submit.prevent="send()">
    <h1>{{ this.contents.find(content => content.id_content === 157)?.title }}</h1>
    <div class="form-group">
      <input
        type="text"
        class="form-control"
        id="name"
        aria-describedby="emailHelp"
        :placeholder="this.contents.find(content => content.id_content === 150)?.title + '*'"
        v-model="name"
        required
      />
    </div>
    <div class="form-group">
      <input
        type="email"
        class="form-control"
        id="email"
        v-model="email"
        placeholder="Email*"
        required
      />
    </div>
    <div class="form-group">
      <textarea
        class="form-control"
        id="exampleFormControlTextarea1"
        rows="3"
        v-model="message"
        :placeholder="this.contents.find(content => content.id_content === 151)?.title + '*'"
        required
      ></textarea>
    </div>
    <div id="small">
      <small>*{{ this.contents.find(content => content.id_content === 152)?.title }}</small>
    </div>
    <div class="form-check">
      <input
        type="checkbox"
        class="form-check-input"
        id="exampleCheck1"
        v-model="check"
        required
      />
      <label class="form-check-label" for="exampleCheck1"
        >{{ this.contents.find(content => content.id_content === 153)?.title }}
        <a href=""
          ><router-link to="/privacity">
          {{ this.contents.find(content => content.id_content === 154)?.title }}
          </router-link></a
        ></label
      >
    </div>
    <button type="submit" class="btn btn">{{ this.contents.find(content => content.id_content === 155)?.title }}</button>
  </form>
</template>
<script>
export default {
  data: function() {
    return { name: "", message: "", email: "", check: false };
  },
  props: {
    contents: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    async send() {
      try {
        await this.$store.dispatch("sendEmail", {
          name: this.name,
          email: this.email,
          message: this.message,
        });
        this.$swal({
          title: this.contents.find(content => content.id_content === 159)?.title,
          text: this.contents.find(content => content.id_content === 160)?.title,
          confirmButtonColor: "#f7941e",
          confirmButtonText: this.contents.find(content => content.id_content === 156)?.title,
        });
        this.name = "";
        this.email = "";
        this.message = "";
        this.check = false;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style scoped>
form {
  padding: 0px 400px 0px 400px;
  text-align: center;
}
h1 {
  padding: 20px;
}
.form-control {
  border: 0px solid black;
  border-bottom: 2px solid grey;
  border-radius: 0px;
}
.form-control:focus {
  font-weight: bold;
  font-size: 20px;
  color: #f7941e;
  box-shadow: none;
  border-color: #f7941e;
}
textarea {
  resize: none;
}
.form-check {
  text-align: center;
}
#small {
  text-align: left;
}
button {
  border: 0px;
  margin-top: 20px;
  background: #f7941e;
  color: white;
}
button:focus {
  box-shadow: none;
}
button:hover {
  box-shadow: #888888;
  background-color: #888888;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
  transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
  color: white;
}
a {
  color: #f7941e;
}
#small {
  text-align: left;
}
@media (max-width: 1000px) {
  h1 {
    padding: 0px;
    margin-bottom: 30px;
  }
  form {
    padding: 0px 20px 0px 20px;
    text-align: center;
  }
}
</style>
